/* eslint-disable */
import { Bubble } from "@tencent/tea-component";
import { useEffect, useState, useRef } from "react";
import { isMobile, isSafari } from "react-device-detect";
import Popup from "@/components/popup";
import MobileReplayChapters from "@/components/popup/mobile-replay";
import "./style.css";

interface Props {
  audioRef: React.MutableRefObject<any>;
  list: any[];
  isMobileIosStatus: React.MutableRefObject<boolean>;
}

export const Contents = ({
  audioRef,
  list,
  isMobileIosStatus,
}: Props) => {
  const [visible, setVisible] = useState(false);
  const [mobilePopupVisible, setMobilePopupVisible] = useState(false);
  // audio 播放进度（用于驱动 Chapter bar 的进度填充）
  const [audioCurrent, setAudioCurrent] = useState<number>(0);
  const [audioDuration, setAudioDuration] = useState<number>(0);

  // 订阅 audio 的 timeupdate / loadedmetadata，实时驱动进度条
  useEffect(() => {
    const audioDom = audioRef.current as HTMLAudioElement | null;
    if (!audioDom) return;
    const onTimeUpdate = () => setAudioCurrent(audioDom.currentTime || 0);
    const onLoadedMeta = () => {
      setAudioDuration(audioDom.duration || 0);
      setAudioCurrent(audioDom.currentTime || 0);
    };
    // 初始同步一次
    onLoadedMeta();
    audioDom.addEventListener("timeupdate", onTimeUpdate);
    audioDom.addEventListener("loadedmetadata", onLoadedMeta);
    audioDom.addEventListener("durationchange", onLoadedMeta);
    return () => {
      audioDom.removeEventListener("timeupdate", onTimeUpdate);
      audioDom.removeEventListener("loadedmetadata", onLoadedMeta);
      audioDom.removeEventListener("durationchange", onLoadedMeta);
    };
  }, [audioRef, mobilePopupVisible, visible]);

  const btnClick = () => {
    if (isMobile) {
      setMobilePopupVisible(true);
      return;
    }
    setVisible((val) => !val);
  };

  /**
   * 把音频跳转到指定秒数，复用 Menus 中的 iOS Safari 兼容逻辑。
   */
  const seekAudioTo = (seconds: number) => {
    const audioDom = audioRef.current;
    if (!audioDom) return;
    if (isMobile && isSafari) {
      const oldVolume = audioDom.volume;
      if (audioDom.paused) {
        audioDom.play?.();
        isMobileIosStatus.current = true;
        audioDom.volume = 0;
      } else {
        isMobileIosStatus.current = false;
      }
      const timeOut = setTimeout(() => {
        if (isMobileIosStatus.current) {
          audioDom.pause();
          audioDom.volume = oldVolume;
        }
        audioDom.currentTime = seconds;
        clearTimeout(timeOut);
      }, 500);
    } else {
      audioDom.currentTime = seconds;
    }
  };

  // 移动端：点击按钮弹出 Popup，PC 端保持原 Bubble 逻辑
  if (isMobile) {
    return (
      <>
        <div className="mark-content" style={{ marginRight: "20px" }}>
          <span
            onClick={btnClick}
            className="speed-btn-text"
            style={{
              color: mobilePopupVisible ? "#006EFF" : "#333333",
              fontSize: "12px",
            }}
          >
            Contents
          </span>
        </div>
        <Popup
          visible={mobilePopupVisible}
          position="bottom"
          onVisibleChange={setMobilePopupVisible}
        >
          <MobileReplayChapters
            title="Chapters"
            list={list}
            currentTime={audioCurrent}
            showClose
            onClose={() => setMobilePopupVisible(false)}
            onItemClick={(item) => {
              seekAudioTo(item.time);
              setAudioCurrent(item.time);
              setMobilePopupVisible(false);
            }}
          />
        </Popup>
      </>
    );
  }
  return (
    <Bubble
      visible={visible}
      trigger="click"
      overlayClassName="content-tootip"
      content={
        <MobileReplayChapters
          title="Chapters"
          list={list}
          currentTime={audioCurrent}
          onClose={() => setVisible(false)}
          onItemClick={(item) => {
            seekAudioTo(item.time);
            setAudioCurrent(item.time);
            setVisible(false);
          }}
        />
      }
    >
      <div
        className="mark-content"
        style={{ marginRight: "30px" }}
      >
        <span
          onClick={btnClick}
          className="speed-btn-text"
          style={{
            color: visible ? "#006EFF" : "#333333",
            fontSize: isMobile ? "12px" : "16px",
          }}
        >
          Contents
        </span>
      </div>
    </Bubble>
  );
};
